import React from 'react';

export default function (props) {
	return (
		<div
			style={{
				...props.style,
			}}
			className={props.className}
		>
<svg xmlns="http://www.w3.org/2000/svg" 
	 viewBox="0 0 117.93 183.73"
	 width={props.width || props.size}
	 height={props.height || props.size}>

	<title>arrow</title>
	<g id="Layer_2" data-name="Layer 2">
		<g id="Layer_7" data-name="Layer 7">
			<path className="cls-1" d="M110.71,62.7C92.16,55.32,74.14,47.56,56.88,37.36A350.29,350.29,0,0,1,6.61,1c-3.69-3.19-9,2-5.4,5.43A305.25,305.25,0,0,0,52.28,45.27c16.23,9.88,33.64,19,51.62,25.58-11.8,14.6-22.46,30.31-32.71,45.94C58.92,135.5,46.66,154.86,37,175.08c-3.14,6.59,6.26,12.3,9.93,5.77,10.91-19.39,21.09-39.06,32.87-58C90.49,105.77,102.25,89.51,113.73,73a4.66,4.66,0,0,0,2.44-3.53l1.1-1.6C119.94,64,113.86,59.22,110.71,62.7Z"
			/>
		</g>
	</g>
</svg>
<style jsx global>
{
	`
		.cls-1 {
			fill: #a6a6a6;
		}	
	`
}
</style>
</div>);
}